import Controller from './Controller';
import ActivitiesModel from '../Apis/Activities';
import { serialize } from 'object-to-formdata';
import Swal from 'sweetalert2'

export default class ActivitiesController extends Controller {
  constructor() {
    super(new ActivitiesModel())
  }
  async updateTeacher(data, poup = true) {
    const formData = serialize(
      data,
      this.options, // optional
    );
    data = formData
    const res = await this.model.updateTeacher(data)
    if (poup) return this.Poup(res);
  }

  async forum_answers(params) {
    const res = await this.model.forum_answers(params);
    return res;
  }

  async activity_answer(data, headers = {}) {
    let res = {}
    if (data.edit) {
      if (data.edit == true) {
        res = await this.model.update_answer(data, headers)
      } else {
        res = await this.model.insert_answer(data, headers)
      }
    } else {
      if (data.id) {
        res = await this.model.update_answer(data, headers)
      } else {
        res = await this.model.insert_answer(data, headers)
      }
    }

    return this.Poup(res);
  }
  async GetHomeWorkAnswers(params) {
    const res = await this.model.GetHomeWorkAnswers(params);
    return res;
  }
  async studentsDataTable(params) {
    const res = await this.model.studentsDataTable(params);
    return res;
  }
  async teacherCourses(params) {
    const res = await this.model.teacherCourses(params);
    return res;
  }
  async teacherCoursesNew(params) {
    const res = await this.model.teacherCoursesNew(params);
    return res;
  }
  async getStudentActivities(params) {
    const res = await this.model.getStudentActivities(params);
    return res;
  }
  async getCourseActivitesDate(params) {
    const res = await this.model.getCourseActivitesDate(params);
    return res;
  }
  async correct_activity(data, headers = {}) {
    let res = {}
    res = await this.model.correct_activity(data, headers);
    return this.Poup(res);
  }
  async updateDates(data, headers = {}) {
    let res = {}
    res = await this.model.updateDates(data, headers);
    return this.Poup(res);
  }
  // new
  async addActivityNew(data){
    return await this.model.addActivityNew(data);
  }

  async editActivityNew(data){
    return await this.model.editActivityNew(data);

  }

  async GetAllNew(params){
    return await this.model.getAllNew(params);

  }

  async DeleteNew(id, recordIds = [], table){
     const result = await Swal.fire({
          position: 'top-start',
          title: 'هل أنت متأكد',
    
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'إلغاء',
    
          confirmButtonColor: '#ce7b2c',
          cancelButtonColor: '#28c76f',
          confirmButtonText: 'نعم ، احذفها!',
        })
    
        if (result.isConfirmed) {
          const res = await this.model.DeleteNew(id, recordIds)
          this.Poup(res);
          if (table) table.refresh()
        }
    
        return []
  }

  //upload to minassah
  async uploadHomeWork(data){
    return this.model.uploadHomeWork(data);
  }

  async uploadForum(data){
    return this.model.uploadForum(data);
  }
  async uploadQuiz(data){
    return this.model.uploadQuiz(data);
  }

  async editHomeWork(data){
    return this.model.editHomeWork(data);
  }

  async editForum(data){
    return this.model.editForum(data);
  }
  async editQuiz(data){
    return this.model.editQuiz(data);
  }

  async getActivityForStudent(id){
    return await this.model.getActivityForStudent(id);
  }

  async getActivityAttempt(activityId, studentId){
    return await this.model.getActivityAttempt(activityId, studentId);
  }

  async getActivityForStudentExam(id){
    return await this.model.getActivityForStudentExam(id);
  }

  async submitActivityForStudent(data, headers = {}){
    return await this.model.submitActivityForStudent(data, headers);
  }
}
